import { SET_PRIMARY_PARAMETER } from './types';

export const setPrimaryParameter = primaryParameter => ({
  type: SET_PRIMARY_PARAMETER, primaryParameter
});
